/**
 * FourUp components refers to marketing page
 *
 * @module views/components/FourUp
 * @memberof -Common
 */
import './FourUp.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Image from '@ulta/core/components/Image/Image';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import Spacer from '@ulta/core/components/Spacer/Spacer';
import Text from '@ulta/core/components/Text/Text';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * Represents a FourUp component
 *
 * @method
 * @param {FourUpProps} props - React properties passed from composition
 * @returns FourUp
 */
export const FourUp = function( props ){

  const titleProps = props.title;
  return (
    <div className={
      classNames( 'FourUp', {
        ...props.backgroundColor ? { ['FourUp__backgroundColor--' + props.backgroundColor]: true } : {}
      } )
    }
    >
      {
        props.backgroundImage && props.backgroundImage.imageUrl &&
        <div className='FourUp__backgroundImg'>
          <Image
            src={ props.backgroundImage.imageUrl }
            { ...spreadProps( {
              metaData: props.backgroundImage.metaData
            } ) }
          />
        </div>
      }
      <div className='FourUp__wrapper'>
        <div className='FourUp__contentSection'>
          {
            ( titleProps || props.subtitle ) &&
            <div className={
              classNames( 'FourUp__heading', {
                'FourUp__heading--Position': props.backgroundImage

              } )
            }
            >
              {
                titleProps &&
                <div className='FourUp__Sectiontitle'>
                  <Text
                    htmlTag={ titleProps.htmlTag }
                    textStyle={ titleProps.textStyle }
                    color={ titleProps.color }
                    textAlign={ titleProps.textAlign || 'center' }
                  >
                    { titleProps.text }
                  </Text>
                  { titleProps.spacerValue &&
                    <Spacer value={ titleProps.spacerValue } />
                  }
                </div>
              }
              {
                props.subtitle &&
                <div className='FourUp__subtitle'>
                  <Text
                    htmlTag='p'
                    textStyle='subtitle-1'
                    textAlign='center'
                  >
                    { props.subtitle }
                  </Text>
                </div>
              }
            </div>
          }
          <div className={
            classNames( 'FourUp__article', {
              'FourUp__article--Position': ( !titleProps?.text && !props.subtitle ) && props.backgroundImage
            } )
          }
          >
            {
              props.article.map( ( content, index ) => (
                <div className='FourUp__content'
                  key={ index }
                >
                  <div className='FourUp__Grid'>
                    <div className='FourUp__Image'>
                      {
                        content.image &&
                        <UltaAsset
                          { ...spreadProps( { ...content.image } ) }
                        />
                      }
                    </div>
                    <div className='FourUp__Data'>

                      <div className='FourUp__Title'>
                        <Text
                          htmlTag='h6'
                          textStyle='title-5'
                          textAlign='center'
                        >
                          { content.title }
                        </Text>
                      </div>
                      <div className='FourUp__Titlesupport'>
                        <Text
                          htmlTag='p'
                          textStyle='body-2'
                          textAlign='center'
                          color='neutral-800'
                        >
                          { content.titleSupport }
                        </Text>
                      </div>
                      {
                        content.linkAction && content.linkAction.label &&
                        <div className='FourUp__Label'>
                          <Link_Huge
                            target='_self'
                            action={ content.linkAction }
                            withHover
                          >
                            <Text
                              htmlTag='span'
                              textStyle='body-2'
                              textAlign='center'
                            >
                              { content.linkAction.label }
                            </Text>
                          </Link_Huge>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              ) )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

/**
  * Property type definitions
  * @typedef FourUpProps
  * @type {object}
  * @property {object} title - Sets the title properties
  * @property {string} subtitle - Sets the subtitle
  * @property {object} backgroundImage - Sets the backgroundImage
  * @property {string} backgroundColor - Sets the backgroundColor
  * @property {array} content - Sets the content
  */
export const propTypes = {
  /** Sets the title properties */
  title: PropTypes.object,
  /** Sets the subtitle */
  subtitle: PropTypes.string,
  /** Set the backgroundImage */
  backgroundImage: PropTypes.object,
  /** Sets the backgroundImage */
  backgroundColor: PropTypes.string,
  /** Sets the content */
  content: PropTypes.array
};


FourUp.propTypes = propTypes;

export default FourUp;
